import { useMutation } from '@tanstack/react-query';
import { setExercises } from '../queries/post';

export function usePrepareExercises() {
  const { mutate, data, isPending } = useMutation({
    mutationKey: ['prepareExercises'], 
    mutationFn: () => setExercises(),
    retry: false
  });

  return { mutate, data, isPending };
}
